// @ts-nocheck
import { convertDataToArrayForMinMax, getNumValuesFromArray } from './common';
import { _isArray } from './common';

export const Max = (rangeValues, ...args) => {
  const set1 = convertDataToArrayForMinMax(rangeValues);
  let set2 = [];
  args.forEach((arg) => {
    const results = convertDataToArrayForMinMax(arg);
    set2 = [...set2, ...results];
  });
  const numValues = getNumValuesFromArray([...set1, ...set2]);
  if (numValues.length < 1) return 0;
  const MAX_NUM = Math.max(...numValues);
  return MAX_NUM;
};

export const Min = (rangeValues, ...args) => {
  const set1 = convertDataToArrayForMinMax(rangeValues);
  let set2 = [];
  args.forEach((arg) => {
    const results = convertDataToArrayForMinMax(arg);
    set2 = [...set2, ...results];
  });
  const numValues = getNumValuesFromArray([...set1, ...set2]);
  if (numValues.length < 1) return 0;
  const MIN_NUM = Math.min(...numValues);
  return MIN_NUM;
};
